module.exports = __webpack_public_path__ + "img/moria.342c010d.png";